import { SalesApiDatasource } from '../data/datasources/sales-api.datasource';
import { SalesRepositoryImpl } from '../data/repositories/sales.repository.impl';

const api = new SalesApiDatasource();
const repository = new SalesRepositoryImpl(api);

export const salesContainer = { repository };
